export default "__VITE_ASSET__2e246733__"